import * as api from "../api/index";
import { updateAuthToken, clearAuthToken } from "../api/index";
import { SUBSCRIPTION_ACTIONS } from "./subscriptionActions";
import { AUTH, END_LOADING, START_LOADING, DB_INITIALIZING, MUST_CHANGE_PASSWORD, PASSWORD_CHANGED, LOGOUT } from "./constants";
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

const clearBrowserSession = (dispatch) => {
  clearAuthToken();
  localStorage.removeItem("profile");
  localStorage.removeItem("hasActiveSubscription");
  dispatch({ type: LOGOUT });
  dispatch({ type: SUBSCRIPTION_ACTIONS.RESET_SUBSCRIPTION_STATUS });
};

export const signin = (formData, openSnackbar, history) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.signIn(formData);

    // MFA required — return the pending token for the second step
    if (data?.mfaRequired) {
      dispatch({ type: END_LOADING });
      return data; // { mfaRequired: true, mfaTempToken }
    }

    dispatch({ type: AUTH, data });
    updateAuthToken(data?.token);

    if (data?.dbStatus === "initializing") dispatch({ type: DB_INITIALIZING });
    if (data?.mustChangePassword) dispatch({ type: MUST_CHANGE_PASSWORD });

    openSnackbar("Signin successfull", SNACKBAR_DURATION_MS, getSnackbarColor("Signin successfull"));
    dispatch({ type: END_LOADING });
    return data;
  } catch (error) {
    openSnackbar(error?.response?.data?.message, SNACKBAR_DURATION_MS, getSnackbarColor("error?.response?.data?.message"));
    dispatch({ type: END_LOADING });
    throw error?.response?.data?.message;
  }
};

export const verifyMfaLogin = (code, mfaTempToken, openSnackbar) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.mfaVerifyLogin(code, mfaTempToken);

    dispatch({ type: AUTH, data });
    updateAuthToken(data?.token);

    if (data?.dbStatus === "initializing") dispatch({ type: DB_INITIALIZING });
    if (data?.mustChangePassword) dispatch({ type: MUST_CHANGE_PASSWORD });

    openSnackbar("Signin successful", SNACKBAR_DURATION_MS, getSnackbarColor("Signin successful"));
    dispatch({ type: END_LOADING });
    return data;
  } catch (error) {
    dispatch({ type: END_LOADING });
    throw error?.response?.data?.message || "Invalid code";
  }
};

export const forgot = (formData) => async (dispatch) => {
  try {
    return await api.forgot(formData);
  } catch (error) {
    const message =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      "Password reset failed";
    const err = new Error(message);
    err.retryAfterSeconds = error?.response?.data?.retryAfterSeconds;
    throw err;
  }
};

export const reset = (formData, history, lang = "en") => async (dispatch) => {
  try {
    await api.reset(formData);
    clearBrowserSession(dispatch);
    history.push(`/${lang}/login`);
  } catch (error) {
    alert(error);
  }
};

export const changeFirstPassword = (newPassword, history, lang) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    await api.changeFirstPassword({ newPassword });
    dispatch({ type: PASSWORD_CHANGED });

    // Update the stored profile so mustChangePassword is no longer flagged
    const profile = JSON.parse(localStorage.getItem("profile") || "{}");
    if (profile?.result) {
      profile.result.mustChangePassword = false;
      localStorage.setItem("profile", JSON.stringify(profile));
    }

    dispatch({ type: END_LOADING });
    history.push(`/${lang}/app/main`);
  } catch (error) {
    dispatch({ type: END_LOADING });
    throw error?.response?.data?.message || "Failed to change password";
  }
};

export const logout = () => (dispatch) => {
  clearBrowserSession(dispatch);
};
